import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import AdminError from '../../../components/admin/admin-error';
import Loader from '../../../components/Loader.js';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { updateTitle } from '../../../helpers/titleHelper';
import { DeleteConfrimationModal } from '../../../components/admin/DeleteConfirmationModal';
import { BudgetYearModal } from "./addBudgetYearsModal";
import {
    addUpdateBudgetYear,
    getAllBudgetYears,
    deleteBudgetYear
} from "../../../api/budgetYearsApi";

export function BudgetYears() {
    updateTitle('Admin', 'BudgetYears');
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState('');
    const [budgetYears, setBudgetYears] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editModel, setEditModel] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [budgetYearModel, setBudgetYearModel] = useState({ id: 0, title: '' });

    const loadBudgetYears = async () => {
        dispatch(showLoading());
        try {
            const res = await getAllBudgetYears();
            if (res.data.success) {
                setBudgetYears(res.data.data);
                setLoadingData(false);
            } else {
                setErrorMessage(res.data.message || 'Failed to load budget years.');
            }
        } catch {
            setErrorMessage('An unknown error occurred while fetching budget years.');
        } finally {
            dispatch(hideLoading());
        }
    };

    useEffect(() => {
        loadBudgetYears();
    }, []);

    const handleSaveBudgetYear = (budgetYearData) => {
        dispatch(showLoading());
        addUpdateBudgetYear(budgetYearData)
            .then((response) => {
                if (response.data.success) {
                    setShowModal(false);
                    loadBudgetYears();
                } else {
                    setErrorMessage(response.data.message || 'Failed to update budget year.');
                }
            })
            .catch(() => {
                setErrorMessage('An unknown error occurred while saving.');
            })
            .finally(() => {
                dispatch(hideLoading());
            });
    };

    const handleDeleteTrigger = (id, budgetYear) => {
        setBudgetYearModel({ id, title: budgetYear });
        setShowDeleteModal(true);
    };

    const handleEditTrigger = (item) => {
        setEditModel(item);
        setShowModal(true);
    };

    const handleDeleteBudgetYear = (budgetYearData) => {
        dispatch(showLoading());
        deleteBudgetYear(budgetYearData.id)
            .then((response) => {
                if (response.data.success) {
                    setShowDeleteModal(false);
                    loadBudgetYears();
                } else {
                    setErrorMessage(response.data.message || 'Failed to delete budget year.');
                }
            })
            .catch(() => {
                setErrorMessage('An error occurred while deleting.');
            })
            .finally(() => {
                dispatch(hideLoading());
            });
    };

    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link className="admin-top-bar-back" to="/admin/">
                        Back
                    </Link>
                </div>
            </div>

            <div className="admin-page-content">
                <AdminError message={errorMessage} onClose={() => setErrorMessage('')} />

                <div className="admin-page-title-wrap">
                    <h1 className="admin-page-heading">Budget Years</h1>
                    <button
                        className="admin-button power"
                        onClick={() => {
                            setEditModel(null);
                            setShowModal(true);
                        }}
                    >
                        Add Budget Year
                        <span className="material-symbols-rounded">add</span>
                    </button>

                    <BudgetYearModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        handleSaveBudgetYear={handleSaveBudgetYear}
                        initialData={editModel}
                    />
                </div>

                <DeleteConfrimationModal
                    show={showDeleteModal}
                    onClose={() => setShowDeleteModal(false)}
                    handleDeleteEvent={handleDeleteBudgetYear}
                    model={budgetYearModel}
                    label={"Budget Year"}
                />

                <div className="admin-section">
                    {loadingData ? (
                        <Loader />
                    ) : (
                        <>
                            {budgetYears && budgetYears.length > 0 ? (
                                budgetYears.map((b) => (
                                    <div className="admin-tall-list-item" key={b.id}>
                                        <p className="admin-tall-list-name">{b.budgetYear}</p>
                                        <div className="admin-tall-list-options">
                                            {b.baseId !== 1 && (
                                                <>
                                                    <button
                                                        className="admin-tall-list-edit"
                                                        onClick={() => handleEditTrigger(b)}
                                                    >
                                                        <span className="material-symbols-rounded">edit</span>
                                                    </button>
                                                    <button
                                                        className="admin-tall-list-edit"
                                                        onClick={() => handleDeleteTrigger(b.baseId, b.budgetYear)}
                                                    >
                                                        <span className="material-symbols-rounded">delete</span>
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="admin-tall-list-item">
                                    <p className="admin-tall-list-name">
                                        There are no active Budget Years in the system.
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>

            </div>
        </div>
    );
}
